var Rollbar = require('rollbar');

module.exports = {
  install: function(Vue, options) {
    Vue.rollbar = new Rollbar(options);
    Vue.prototype.$rollbar = Vue.rollbar;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-rollbar/index.js
// module id = eHNG
// module chunks = 4